export default "__VITE_ASSET__Du1Gn7e4__"